<template>
    <div id="main">
        <div id="banner">
            <img :src="require('./../assets/logo.png')" />
        </div>
        <div id="content">
            <v-container grid-list-md text-xs-center v-if="auth.isAuth()">
                <v-progress-circular :size="100" :width="10" color="red" indeterminate v-if="items.length <= 0"></v-progress-circular>
                <v-expansion-panels class="elevation-24" v-model="panel">
                    <v-expansion-panel v-for="(v, i) in items" :key="i">
                        <v-expansion-panel-header class="display-1 text-uppercase">
                            {{ i }}
                            <template v-slot:actions>
                                <v-icon :color="getColorAlarm(v)">alarm</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-data-table :headers="headers" :items="v" class="elevation-1">
                                <template v-slot:item.name="{ item }">
                                    <p class="text-capitalize">{{ item.name }}</p>
                                </template>
                                <template v-slot:item.sensor="{ item }">
                                    <p class="text-capitalize">{{ item.sensor }}</p>
                                </template>
                                <template v-slot:item.part="{ item }">
                                    <v-chip color="secondary" dark label width="100vw">{{ item.part }}</v-chip>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn
                                        :loading="lockButton"
                                        v-if="item.action == 'switch' && item.part == 1"
                                        small
                                        dark
                                        color="red"
                                        class="elevation-24"
                                        @click="send(0, item)"
                                    >
                                        OFF
                                    </v-btn>
                                    <v-btn
                                        :loading="lockButton"
                                        v-if="item.action == 'switch' && item.part == 0"
                                        small
                                        dark
                                        color="green"
                                        class="elevation-24"
                                        @click="send(1, item)"
                                    >
                                        ON
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
            <v-container grid-list-x v-else>
                <v-switch color="primary" label="Quer uma descrição informal?" v-model="isNerd" inset></v-switch>
                <h1 v-if="isNerd">Conheça a SDeveloper - Inovação em Código</h1>
                <h1 v-else>Bem-vindo à SDeveloper - Transformando Ideias em Tecnologia</h1>
                <v-divider class="mb-4"></v-divider>
                <div class="body-1 mb-4" v-if="isNerd">
                    <p>
                        Na SDeveloper, somos apaixonados por transformar ideias malucas em tecnologia incrível. Não somos uma empresa convencional - somos uma equipe de nerds
                        criativos e amantes de café que adoram desafios.
                    </p>

                    <h2 class="mt-10 mb-4">O Que Fazemos:</h2>
                    <p>
                        <strong>1. Desenvolvimento de Software Maluco:</strong> Adoramos criar software maluco e divertido para sistemas embarcados. Seja um gadget divertido ou um
                        projeto sério, estamos prontos para dar vida à sua visão.
                    </p>
                    <p>
                        <strong>2. Websites Que Brilham:</strong> Não fazemos apenas websites chatos, fazemos sites que brilham! Nossa equipe de desenvolvedores web é especialista
                        em criar experiências online incríveis.
                    </p>
                    <p>
                        <strong>3. Consultoria com um Toque de Loucura:</strong> Além de código, oferecemos consultoria em tecnologia com um toque de loucura. Nossa abordagem
                        criativa pode ajudar a sua empresa a se destacar no mercado.
                    </p>

                    <h2 class="mt-10 mb-4">Por Que Escolher a SDeveloper?</h2>
                    <ul>
                        <li><strong>Amamos o Que Fazemos:</strong> Não somos apenas nerds; somos nerds apaixonados por tecnologia.</li>
                        <li><strong>Equipe de Loucos:</strong> Nossa equipe é composta por pessoas criativas e que amam desafios. Não temos medo de pensar fora da caixa.</li>
                        <li><strong>Inovação Sem Fim:</strong> Acompanhamos as tendências mais malucas e as transformamos em realidade. A inovação está no nosso DNA.</li>
                        <li><strong>Clientes Felizes:</strong> Quando nossos clientes sorriem, nós sorrimos. Trabalhamos duro para superar as expectativas.</li>
                        <li><strong>Projetos Alucinantes:</strong> Nossos projetos anteriores são uma mistura de loucura e sucesso. Mal podemos esperar para começar o próximo!</li>
                    </ul>

                    <p>
                        Se você está pronto para abraçar a loucura e transformar suas ideias em tecnologia de outro mundo, a SDeveloper está aqui para ajudar.
                        <a href="mailto:anderson@sdeveloper.io">Entre em contato conosco</a> hoje mesmo e vamos começar a fazer mágica digital juntos!
                    </p>
                </div>
                <div class="body-1 mb-4" v-else>
                    <p>
                        Na SDeveloper, estamos empenhados em impulsionar a inovação e transformar as visões dos nossos clientes em realidade por meio de soluções de software
                        excepcionais. Com uma experiência incomparável em desenvolvimento de software embarcado e web, estamos prontos para ser o seu parceiro de confiança na
                        jornada da tecnologia.
                    </p>

                    <h2 class="mt-12 mb-2">O Que Fazemos:</h2>
                    <p>
                        <strong>1. Desenvolvimento de Software Embarcado:</strong> Somos especialistas em criar software de alto desempenho para sistemas embarcados em uma
                        variedade de setores, desde eletrônicos de consumo até automação industrial. Nossa equipe altamente qualificada trabalha com as mais recentes tecnologias
                        para garantir que seus produtos se destaquem no mercado.
                    </p>
                    <p><strong>2. Desenvolvimento Web:</strong> Criamos experiências web excepcionais que não apenas atraem, mas também retêm usuários.</p>
                    <p>
                        <strong>3. Consultoria em Tecnologia:</strong> Além do desenvolvimento, oferecemos consultoria especializada em tecnologia para ajudar sua empresa a tomar
                        decisões informadas e estratégicas em um cenário tecnológico em constante evolução.
                    </p>

                    <h2 class="mt-8 mb-2">Por Que Escolher a SDeveloper?</h2>
                    <ul>
                        <li>
                            <strong>Experiência Comprovada:</strong> Com anos de experiência no setor, entregamos resultados excepcionais que superam as expectativas dos clientes.
                        </li>
                        <li>
                            <strong>Equipe de Especialistas:</strong> Nossa equipe é formada por profissionais altamente qualificados e experientes que estão comprometidos em
                            fornecer soluções de alta qualidade.
                        </li>
                        <li>
                            <strong>Inovação Constante:</strong> Mantemos-nos atualizados com as tendências tecnológicas mais recentes e incorporamos as melhores práticas em nosso
                            trabalho.
                        </li>
                        <li>
                            <strong>Compromisso com o Cliente:</strong> Valorizamos nossos clientes e trabalhamos em estreita colaboração com eles para garantir que suas
                            necessidades sejam atendidas de maneira eficaz e oportuna.
                        </li>
                        <li>
                            <strong>Resultados Comprovados:</strong> Nossos projetos anteriores são um testemunho de nosso compromisso com a excelência. Estamos orgulhosos de nossa
                            trilha de sucesso.
                        </li>
                    </ul>

                    <p>
                        Se você está pronto para levar sua empresa ao próximo nível com soluções de software de classe mundial, a SDeveloper está à disposição para ajudar.
                        <a href="mailto:anderson@sdeveloper.io">Entre em contato conosco</a> hoje mesmo e comece a transformar suas ideias em tecnologia de ponta.
                    </p>
                </div>
                <div class="body-1 mb-4">Se sua empresa não possui uma equipe de desenvolvimento, estamos para desenvolver sua solução.</div>
                <h1 class="mt-12">Áreas de atuação</h1>
                <v-divider class="mb-4"></v-divider>
                <div class="text-left">
                    <v-card class="mx-auto" max-width="500">
                        <v-list>
                            <v-list-item-group v-model="model">
                                <v-list-item v-for="(item, i) in tecs" :key="i">
                                    <v-list-item-icon>
                                        <v-icon v-text="item.icon"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.text"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </div>
                <h1 class="mt-12">Clientes</h1>
                <v-divider class="mb-4"></v-divider>
                <v-layout wrap>
                    <v-flex xs12 md6 lg4 xl3 v-for="(item, i) in works" :key="i">
                        <v-card class="mx-auto my-12" max-width="374" min-height="550">
                            <v-img height="250" :src="require(`./../assets/${item.img}`)" />
                            <v-card-title v-if="item.title">{{ item.title }}</v-card-title>
                            <v-card-text v-if="item.description">{{ item.description }}</v-card-text>
                            <div style="position: absolute; bottom: 0; width: 100%" v-if="item.link">
                                <v-divider />
                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn color="primary" small :href="item.link" target="_blank">
                                        <strong>Acesse o site</strong>
                                    </v-btn>
                                </v-card-actions>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <v-fab-transition>
            <v-btn color="primary" dark fab fixed bottom right @click="info.show = !info.show">
                <v-icon>info</v-icon>
            </v-btn>
        </v-fab-transition>
        <Info :show="info.show" @onClose="closeInfo()"></Info>
    </div>
</template>

<script>
import api from "../helpers/api";
import auth from "../helpers/auth";
import Info from "../components/shared/Info.vue";

export default {
    name: "Home",
    mounted() {
        this.update();
        this.timer = setInterval(this.update, 10000);
    },
    components: {
        Info,
    },
    data() {
        return {
            api,
            auth,
            lockButton: true,
            info: {
                show: false,
            },
            processing: false,
            timer: null,
            isNerd: false,
            panel: 0,
            headers: [
                { text: "Local", align: "left", value: "name" },
                { text: "Sensor", align: "left", value: "sensor" },
                { text: "Última atualização", align: "left", value: "date" },
                { text: "Valor", sortable: false, value: "part" },
                { text: "Ação", sortable: false, value: "action" },
            ],
            items: [],
            tecs: [
                {
                    icon: "memory",
                    text: "Embarcados (IOT)",
                },
                {
                    icon: "computer",
                    text: "Páginas web (PWA - Progressive Web Apps)",
                },
                {
                    icon: "smartphone",
                    text: "Aplicativos multiplataformas",
                },
                {
                    icon: "api",
                    text: "Integração de sistemas",
                },
                {
                    icon: "topic",
                    text: "Preparação de ambiente para desenvolvimento ágil",
                },
                {
                    icon: "cloud",
                    text: "Preparação de infraestrutura",
                },
            ],
            works: [
                {
                    img: "treetech.png",
                    title: "Treetech Tecnologia",
                    description: "Gateway de comunicação para troca de informações entre dispositivos e sistemas na área de energia.",
                    link: "https://www.treetech.com.br/sd/",
                },
                {
                    img: "r2pp.png",
                    title: "R2PP",
                    description: "Gestão de especialistas. Implementação completa da gestão de entrada e saídas de especialistas e plano de demandas de clientes.",
                    link: "https://r2pp.com.br",
                },
                {
                    img: "incharge.png",
                    title: "INCHARGE",
                    description:
                        "Sistema de carregamento para carros elétricos. O sistema de coleta de dados dos carregadores que são enviados para nuvem, feito também o sistema de cadastro, geração de informações para usuários e adminitração remota dos carregadores. Empresa parceira situada em Santa Rita do Sapucaí, cidade onde escolhi para iniciar minha jornada de estudos.",
                    link: "https://incharge.app",
                },
                {
                    img: "labvida.png",
                    title: "Labóratorio de Análises Clínicas",
                    description:
                        "Software desenvolvido para gestão de clientes e exames laboratoriais. Além de toda parte de cadastro básico o software também gera relatórios, impressão de guias de atendimento e resultados. Ultimo modulo desenvolvido foi a disponibilização dos exames online. Esse projeto foi desenvolvido em parceria com o LabVida que possui sua sede em Brasópolis, minha cidade natal.",
                    link: "https://labvida.app",
                },
                {
                    img: "jfa.png",
                    title: "JFA",
                    description:
                        "Desenvolvimento de aplicativos para controle de hardware de entrentenimento automotivo. Foram alguns projetos desenvolvidos em parceria com a empresa JFA de Belo Horizonte.",
                    link: "https://automotivo.jfaeletronicos.com/produtos/processador-j4-redline/",
                },
                {
                    img: "db1.jpg",
                    title: "Imersão em uma fábrica de Software",
                    description:
                        "Aqui fiquei um ano fazendo transferência de conhecimento de um projeto inicialmente desenvolvido por mim e que demandou uma grande equipe. Então foi contratada a empresa DB1 situado na cidade de Maringá para continuar o projeto. Durante esse período fortaleci meu conhecimento com metodologias ágeis e o trabalho em equipe maior.",
                },
                {
                    img: "petshop.jpg",
                    title: "Petshop",
                    description: "Sistema de gestão para petshop. Desenvolvido em parceria com o PetShop Reino Animal situado na minha cidade natal Brasópolis.",
                },
                {
                    img: "sites.png",
                    title: "Sites",
                    description: "Sites desenvolvi vários, alguns com objetivo pessoal para conhecimento de novas tecnologias, outros com parcerias.",
                },
                {
                    img: "maker.png",
                    title: "Cultura maker",
                    description: "Ainda não consegui um espaço para reunir as pessoas, mas mantenho um grupo com objetivo de motiva-los a fazer suas próprias coisas.",
                },
            ],
            timeline: [
                { date: "1987", title: "Nascimento", description: "15 de outubro de 1987, eis que surge mais uma pessoa na terra." },
                {
                    date: "2004",
                    title: "Curso técnico em eletônica industrial",
                    description: "Ainda durante o ensino médio iniciei o curso técnico em eletrônica, foi onde descobri o que queria para o futuro, desenvolvimento de software.",
                },
                { date: "2006", title: "Universidade", description: "A universidade que escolhi foi o INATEL e o curso de engenheria de computação." },
                {
                    date: "2009",
                    title: "Estágio",
                    description:
                        "Aqui aprendi muito com duas grandes pessoas, Pina e Mury, que além de professores do INATEL eram sócios da empresa que me deu a opurtunidade de estágio. Com certeza foi a época de maior aprendizado na minha vida.",
                },
                { date: "2011", title: "Formatura em engenharia da computação" },
                { date: "2013", title: "DB1", description: "Ano em que fiquei fazendo transfência de conhecimento dentro de uma fábrica de software." },
                { date: "2014", title: "Treetech", description: "Mudança para Atibaia para um novo desafio." },
                { date: "2016", title: "Pós graduação em engenharia de software" },
                { date: "2020", title: "Reabertura da empresa para parcerias de desenvolvimento de software" },
            ],
        };
    },
    computed: {},
    methods: {
        getColorAlarm(item) {
            if (item) return "success";
            else return "error";
        },
        closeInfo() {
            this.info.show = false;
        },
        send(newVal, item) {
            this.lockButton = true;
            this.api.put(
                this.$http,
                "status",
                item.id,
                { message: newVal ? "1" : "0", topic: item.topic },
                (res) => {
                    this.$root.$emit("msgSuccess", res.message ? res.message : "Dados enviado com sucesso.");
                },
                (res) => {
                    this.$root.$emit("msgError", res.message ? res.message : "Erro ao enviar dados.");
                }
            );
        },
        update() {
            if (auth.isAuth() && !this.processing) {
                this.processing = true;
                this.api.get(
                    this.$http,
                    "status",
                    (p) => {
                        this.items = {};
                        p.forEach((i) => {
                            let topic = i.topic.split("/");
                            if (!this.items[topic[1]]) {
                                this.items[topic[1]] = [];
                            }
                            this.items[topic[1]].push({
                                id: i.id,
                                topic: i.topic,
                                name: `${topic[2]} (${topic[3]})`,
                                sensor: `${topic[4]}`,
                                action: topic[5] ? `${topic[5]}` : undefined,
                                part: i.message,
                                date: i.date,
                            });
                        });
                        this.lockButton = false;
                        this.processing = false;
                    },
                    () => {
                        this.processing = false;
                    }
                );
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped>
#content {
    width: 100vw;
    height: 84vh;
}
#banner {
    width: 100vw;
    height: 16vh;
    background-color: var(--v-primary-base);
}
#banner img {
    width: auto;
    height: 14vh;
    margin-top: 1vh;
}
</style>